import { render, staticRenderFns } from "./stockFlowReturnDetail.vue?vue&type=template&id=52ac367a&scoped=true"
import script from "./stockFlowReturnDetail.vue?vue&type=script&lang=js"
export * from "./stockFlowReturnDetail.vue?vue&type=script&lang=js"
import style0 from "./stockFlowReturnDetail.vue?vue&type=style&index=0&id=52ac367a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ac367a",
  null
  
)

export default component.exports